module.exports = __webpack_public_path__ + "img/button-key-hover.c1cbfefc.svg";